import { useEffect, useState } from 'react';

export enum DeviceType {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
}

const getDeviceType = (width: number): DeviceType => {
    if (width < 768) return DeviceType.Mobile;
    if (width < 1024) return DeviceType.Tablet;
    return DeviceType.Desktop;
};
// eslint-disable-next-line newline-after-var
const useDeviceType = (): [DeviceType] => {
    const [deviceType, setDeviceType] = useState<DeviceType>(() => getDeviceType(window.innerWidth));

    useEffect(() => {
        const handleResize = () => {
            setDeviceType(getDeviceType(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    return [deviceType];
};
export default useDeviceType;
